<template>
  <div class="start_playing page container">

    <Header></Header>

    <div v-for="(question, index) in quiz.questions" :key="index">
      <div v-show="index === questionIndex">

        <div class="row clearfix pb-5">
          <div class="question_area text-right col-md-9">
            <h1 class="title pb-2">{{ question.questiontitle }}</h1>
            <h2 class="question">{{ question.text }}</h2>
          </div>

          <div class="timer col-md-3">
            <span class="icon_area"><i class="far fa-clock"></i></span>
            <span class="timer_title text-right">
              <h5>الوقت المتبقي</h5>
              <p>
                <span>{{ countDown }}</span>
                <span>ثانية</span>
              </p>
            </span>
          </div>
        </div>

        <div class="top_question"><img alt="logo" src="@/assets/images/top.png"></div>

        <div class="question_content">
          <div class="select_answer">
            <span v-for="(item, index) in question.choices" :key="index">
              <input class="checkbox" type="radio" v-bind:id="'choice'+index" name="choice" @click="getChoice" :value="item">
              <label v-bind:for="'choice'+index">{{ item }}</label>
            </span>
          </div>

        </div>

      </div>
    </div>

    <div v-if="this.answered == 1" class="modal fade show" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" style="display:block" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <div class="modal-body p-5">
            <img :src="require('@/assets/images/success/success'+this.answeredimg+'.png')" alt="">
            <div class="p-3">
              <h3>مبروك</h3>
              <p>تم إجابة السؤال في أقل من 10 ثواني</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.answered == 2" class="modal fade show" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" style="display:block" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button @click="close10sc" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <div class="modal-body p-5">
            <img src="@/assets/images/10sc.png" alt="">
            <div class="p-3">
              <h3>عفوا</h3>
              <p>تجاوزت إجابتك للسؤال أكثر من 10 ثواني</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="imgpr">
      <kinesis-container>
        <kinesis-element :strength="20">
          <img :src="require('@/assets/images/q/q'+this.qimg+'.png')" alt="">
        </kinesis-element>
      </kinesis-container>
    </div>

  </div>
</template>

<script>

var choicesarray = ['ا','ب','ت','ث','ج','ح','خ','د','ذ','ر','ز','ط','ظ','ك','ل','م','ن','ص','ض','ع','غ','ف','ق','س','ش','ه','و','ي'];
var quiz = {
  // title: 'My quiz',
  questions: [
    {
      questiontitle: "السؤال الأول",
      text: "ماهو أول حرف من إسم زوجك / زوجتك؟",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال التاني",
      text: "أول حرف من إسم   الأكلة المفضلة لزوجك / زوجتك",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال الثالث",
      text: "أول حرف من إسم   والدة  زوجك / زوجتك",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال الرابع",
      text: "أول حرف من إسم   أصغر أبنائك",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال الخامس",
      text: "أول حرف من إسم   اللون الذي يفضله زوجك / زوجتك",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال السادس",
      text: "أول حرف من إسم   الحي الذي كان يسكن فيه زوجك / زوجتك قبل الزواج",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال السابع",
      text: "أول حرف من إسم   الشهر الذي رزقتم فيه بأول مولود",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال الثامن",
      text: "أول حرف من إسم   الأكلة اللي ما يحبها زوجك / زوجتك",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال التاسع",
      text: "أول حرف من إسم   السنة الدراسية لأكبر الأبناء",
      choices: choicesarray
    },
    {
      questiontitle: "السؤال العاشر",
      text: "أول حرف من إسم   مكان الخروج المفضل لزوجتك / زوجك",
      choices: choicesarray
    }
  ]
};


import Header from '@/components/Header.vue'
export default {
  name: "StartPlaying",
  components: {Header},
  data() {
    return {
      quiz: quiz,
      questionIndex: 0,
      countDownNum : 10,
      countDown : 10,
      answered: 0,
      result: 0,
      finish: 0,

      answeredimg: '',
      qimg:'',

      bg: 'https://previews.customer.envatousercontent.com/files/288653028/preview.mp3',
      click: 'https://previews.customer.envatousercontent.com/files/237411076/preview.mp3',
      alart: 'https://previews.customer.envatousercontent.com/files/176790740/preview.mp3',
      tick: 'http://soundbible.com/mp3/Tick-DeepFrozenApps-397275646.mp3'
    }
  },

  created() {
    this.get_confetti()
  },

  mounted() {
    this.countDownTimer()
  },

  methods: {

    getChoice: function () {
      this.questionIndex++;
      this.calcSc()
      if (this.questionIndex === 10) {
        this.$router.push({ name: 'Success', params: { result: this.result } })
      } else {
        this.playAudio(this.click);
        this.answered = 1
      }
      this.getRandomNum()
      this.getRandomNumQImg()
    },

    countDownTimer() {
      if (!this.finish) {
        if(this.countDown > 0) {
          if (!this.answered) {
            setTimeout(() => {
              this.countDown -= 1
              this.countDownTimer()
            }, 1000)
            this.playAudio(this.tick)
          }
        } else {
          this.calcSc()
          this.questionIndex++;
          if (this.questionIndex === 10) {
            this.$router.push({ name: 'Success', params: { result: this.result } })
          } else {
            this.answered = 2
            this.playAudio(this.alart);
          }
        }
      }
    },

    close: function () {
      this.answered = 0
      this.countDown = 10
      this.countDownTimer()
    },

    close10sc: function () {
      this.answered = 0
      this.countDown = 10
      this.countDownTimer()
    },

    next: function() {
      this.questionIndex++;
      this.calcSc()
      this.countDown = 10
      this.answered = 0
      this.countDownTimer()
    },

    closeGoBack: function() {
      this.$router.push('/')
    },

    calcSc: function() {
      this.result += (this.countDown != this.countDownNum) ? this.countDownNum - this.countDown : 1
    },

    playAudio: function(audiofile) {
      var audio = new Audio(audiofile);
      audio.pause();
      audio.currentTime = 0;
      audio.play();
    },

    getRandomNum: function () {
      this.answeredimg = Math.floor(Math.random()*(4-1+1)+1);
    },
    getRandomNumQImg: function () {
      this.qimg = Math.floor(Math.random()*(5-1+1)+1);
    },

    get_confetti () {
      this.$confetti.start({
        particlesPerFrame: 0.3,
        particles: [
          {
            type: 'heart',
            colors: [
              'red',
              'pink',
            ],
          },
          {
            type: 'rect',
            colors: [
              '#006F44',
            ],
          },
        ],
      });
      // setTimeout(() => this.$confetti.stop(), 3000);
    }

  },

  beforeDestroy() {
    this.finish = 1
  },

}
</script>


<style lang="scss" scoped>
.start_playing {
  position: relative;
}
#exampleModalCenter {
  background: rgba(34, 34, 34, 0.8);
  button.close {
    width: 40px;
    display: block;
    position: relative;
    height: 40px;
  }
  .modal-body {
    i {
      font-size: 120px;
      color: #E1526A;
    }
    h3 {
      color: #E1526A;
      margin-top: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
.resulttest {
  color: #F2B101;
}
.imgpr {
    position: absolute;
    bottom: 0px;
    right: -90px;
}
</style>
